import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IExcelMaped_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IExcelMaped_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GoalProgressImportDelete: number;
  GoalProgressImportDelete_dummy: number;
  ImportMappedExcel: any;
  ImportMappedExcel_dummy: any;
  GoalExcelImportUpdate: number;
  GoalExcelImportUpdate_dummy: number;
}

export class ExcelMaped_ScreenBase extends React.PureComponent<
  IExcelMaped_ScreenProps,
  any
> {
  ml = [
    {
      Id: "f6e17cbf-9877-1e37-1dda-7f0e2f0194a4",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "58f12691-42c0-4569-8d3d-7de148711af0",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "8773fc2e-db45-4b45-9eb0-0c2d02630a4f",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 323718, PropertyName: "value", Value: "Excel" },
        { Id: 19756, PropertyName: "label", Value: "İmportExcel" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GoalProgressImportDelete: 0,
      ImportMappedExcel: "",
      GoalExcelImportUpdate: 0,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("excelmaped", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
    }

    KuikaAppManager.calculateAndSetBodyHeight("excelmaped", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("excelmaped", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  ExcelMapedComponent_258398_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ExcelMapedComponent_19756_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ExcelMaped/ExcelMapedComponent_19756_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GoalProgressImportDelete = result?.data.goalProgressImportDelete;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ExcelMapedComponent_19756_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ExcelMapedComponent_19756_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ImportMappedExcel =
      await ReactSystemFunctions.openImportMappedExcelModal(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "72ae4cf8-034c-4ae5-8fe9-8222a62561b3",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName(
          "GoalProgressImport",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("Id", "string"),
        ReactSystemFunctions.convertToTypeByName(
          '[{"isEnabled":true,"source":"Id","alias":"Id","primaryKey":null,"isRequired":true},{"isEnabled":false,"source":"DealerGoalsId","alias":"DealerGoalsId","primaryKey":null,"isRequired":false},{"isEnabled":true,"source":"DieselQuantity","alias":"DieselQuantity","primaryKey":null,"isRequired":false},{"isEnabled":true,"source":"DieselQuantity2","alias":"DieselQuantity2","primaryKey":null,"isRequired":false},{"isEnabled":true,"source":"DieselTurnover","alias":"DieselTurnover","primaryKey":null,"isRequired":false},{"isEnabled":true,"source":"DieselTurnover2","alias":"DieselTurnover2","primaryKey":null,"isRequired":false},{"isEnabled":true,"source":"MaturityPayment","alias":"MaturityPayment","primaryKey":null,"isRequired":false},{"isEnabled":true,"source":"PeriodicSalesQuantity","alias":"PeriodicSalesQuantity","primaryKey":null,"isRequired":false},{"isEnabled":true,"source":"PortableQuantity","alias":"PortableQuantity","primaryKey":null,"isRequired":false},{"isEnabled":false,"source":"PortableQuantity2","alias":"PortableQuantity2","primaryKey":null,"isRequired":false},{"isEnabled":true,"source":"PortableTurnover","alias":"PortableTurnover","primaryKey":null,"isRequired":false},{"isEnabled":false,"source":"PortableTurnover2","alias":"PortableTurnover2","primaryKey":null,"isRequired":false},{"isEnabled":true,"source":"Quarter","alias":"Quarter","primaryKey":null,"isRequired":true},{"isEnabled":true,"source":"SparePartTurnover","alias":"SparePartTurnover","primaryKey":null,"isRequired":false},{"isEnabled":false,"source":"SparePartTurnover2","alias":"SparePartTurnover2","primaryKey":null,"isRequired":false},{"isEnabled":true,"source":"Stock","alias":"Stock","primaryKey":null,"isRequired":false},{"isEnabled":true,"source":"ValidYear","alias":"ValidYear","primaryKey":null,"isRequired":true},{"isEnabled":true,"source":"VKN","alias":"VKN","primaryKey":null,"isRequired":true}]',
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("[]", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ExcelMapedComponent_19756_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ExcelMapedComponent_19756_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {};

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ExcelMaped/ExcelMapedComponent_19756_onClick2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GoalExcelImportUpdate = result?.data.goalExcelImportUpdate;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
